export const state = {
  companies: [],
  isLoading: false,
  totalRecords: 0,
  companyPerPage: 200,
  activePage: 1,
}
